import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight, Phone, FileText } from "lucide-react";

const ctaVariants = [
  {
    headline: "Not Sure Where to Start?",
    subtext: "That's completely normal. Let's have a quick conversation about what's going on in your practice — no pressure, no pitch.",
    primaryLabel: "Book a Free Call",
    primaryLink: "/consultation",
    secondaryLabel: "Get an Instant Quote",
    secondaryLink: "/quote",
    bg: "bg-gradient-to-r from-rnb-navy to-[#1e3a5f]",
  },
  {
    headline: "See What This Looks Like for Your Practice",
    subtext: "Every engagement starts with understanding your specific situation. Get a custom quote in under 2 minutes.",
    primaryLabel: "Get Your Custom Quote",
    primaryLink: "/quote",
    secondaryLabel: "Talk to Our Team",
    secondaryLink: "/consultation",
    bg: "bg-gradient-to-r from-[#1A5276] to-rnb-blue",
  },
  {
    headline: "Let's Fix What's Not Working",
    subtext: "You don't have to figure this out alone. We've helped dozens of practices solve the exact challenges you're facing right now.",
    primaryLabel: "Schedule a Consultation",
    primaryLink: "/consultation",
    secondaryLabel: "Explore Our Services",
    secondaryLink: "/services",
    bg: "bg-gradient-to-r from-rnb-navy to-[#2471A3]",
  },
  {
    headline: "Ready to Take the Next Step?",
    subtext: "The sooner you address the bottlenecks, the sooner your practice starts running the way it should.",
    primaryLabel: "Let's Talk",
    primaryLink: "/consultation",
    secondaryLabel: "See Pricing",
    secondaryLink: "/quote",
    bg: "bg-gradient-to-r from-[#1A2636] to-[#1A5276]",
  },
];

const MidPageCTA = ({ variant = 0, image = null }) => {
  const cta = ctaVariants[variant % ctaVariants.length];

  return (
    <section className={`relative py-14 sm:py-16 ${cta.bg} overflow-hidden`} data-testid="mid-page-cta">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/5 rounded-full blur-2xl" />
        <div className="absolute -bottom-16 -left-16 w-48 h-48 bg-rnb-teal/10 rounded-full blur-2xl" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`flex flex-col ${image ? "lg:flex-row lg:items-center lg:gap-12" : "items-center text-center"}`}>
          {image && (
            <div className="w-full lg:w-2/5 mb-8 lg:mb-0">
              <img
                src={image}
                alt="Healthcare consulting"
                className="rounded-2xl shadow-xl w-full h-48 sm:h-56 lg:h-64 object-cover"
                loading="lazy"
              />
            </div>
          )}
          <div className={`flex-1 ${image ? "" : "max-w-2xl"}`}>
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
              {cta.headline}
            </h3>
            <p className="text-white/75 text-base sm:text-lg mb-6 leading-relaxed">
              {cta.subtext}
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to={cta.primaryLink}>
                <Button
                  size="lg"
                  className="bg-rnb-teal hover:bg-rnb-teal/90 text-white rounded-full px-6 py-5 font-semibold shadow-lg hover:-translate-y-0.5 transition-all duration-300"
                >
                  {cta.primaryLink === "/consultation" ? (
                    <Phone className="w-4 h-4 mr-2" />
                  ) : (
                    <FileText className="w-4 h-4 mr-2" />
                  )}
                  {cta.primaryLabel}
                </Button>
              </Link>
              <Link to={cta.secondaryLink}>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-white/25 text-white hover:bg-white/10 rounded-full px-6 py-5 font-semibold transition-all duration-300"
                >
                  {cta.secondaryLabel}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
